module.exports = __webpack_public_path__ + "static/media/home-finding.7242bcc5.jpeg";